<template>
  <div class="audio-player">
    <div class="audio-player__cnt" @click="handlePlayToggle()">
      <div class="audio-player__cnt-icon" :class="{'icon-play': !paused}"></div>
    </div>
    <audio ref="audio" :controls="controls" :src="voiceUrl" class="panda-audio-player">
      Your browser does not support the<code>audio</code> element.
    </audio>
  </div>
</template>

<script>
import {closeAllAudio} from '@/common/js/util'
export default {
  name: 'AudioPlayer',
  props: {
    voiceUrl: {
      type: String,
      default: ''
    },
    controls: {
      type: Boolean,
      default: false
    },
    replayFromStart: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      paused: true
    }
  },
  mounted() {
    this.$refs.audio.addEventListener('ended', () => {
      this.paused = true;
      this.$refs.audio.load();
    });
    this.$refs.audio.addEventListener('play', () => {
      this.paused = false;
    });
    this.$refs.audio.addEventListener('pause', () => {
      this.paused = true;
      if (this.replayFromStart) {
        this.$refs.audio.load(); // 下次从头开始播放
      }
    });
  },
  beforeDestroy() {
    this.$refs.audio.pause();
  },
  methods: {
    async handlePlayToggle() {
      await closeAllAudio();
      if (this.paused) {
        this.$emit('play');
        this.$refs.audio.play();
      } else {
        this.paused = true;
        this.$refs.audio.pause();
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .audio-player {
    display: inline-block;
    .audio-player__cnt-icon {
      width: 24px;
      height: 24px;
      background: url('@/common/images/volume_2.png') no-repeat center center / contain;
      &.icon-play {
        animation: trumpetPlay 1s steps(2) infinite;
      }
    }
  }
  @keyframes trumpetPlay {
    0% {
      background-image: url("@/common/images/volume_0.png");
    }
    50% {
      background-image: url("@/common/images/volume_1.png");
    }
    100% {
      background-image: url("@/common/images/volume_2.png");
    }
  }
</style>
